import RequestService from "./request-service";
import Utils from "./utils";
import { RouterRequestType } from "./constants";

export default class EmbeddedContentView {
  #ui;
  #requestType = RouterRequestType.Standard;

  init($container, isModal = false) {
    if (isModal) {
      this.#requestType = RouterRequestType.Modal;
    }

    this.#cacheUiElements($container);
  }

  async load(url, data = {}, http_method = "GET") {
    await this.#setContentOnLoad(url, data, http_method);
  }

  #cacheUiElements($container) {
    this.#ui = {
      container: $container,
      content: $container.find("#content"),
      spinner: $container.find(".spinner")
    };
  }

  #setContent(newContent) {
    this.#ui.content.html(newContent);
    // Reparse a new form (if it exists) to apply the validators
    let $form = this.#ui.container.find("form");
    if ($form.length > 0) {
      $.validator.unobtrusive.parse($form);
    }
  }

  async #setContentOnLoad(url, additionalData = {}, http_method = "GET") {
    let content;
    let urlObj;

    // Set the routing type
    let data = {};
    data["r"] = this.#requestType;
    data = { ...data, ...additionalData };

    this.#setUiLoading();

    try {
      urlObj = Utils.newURL(url);

      if (http_method === "POST") {
        content = await RequestService.post(urlObj, data);
      }
      else {
        content = await RequestService.navigate(urlObj, data);
      }

      this.#setContent(content);

      this.#ui.container.trigger("content-loaded", { url: urlObj });
    } catch (errResp) {
      this.#setUiLoaded();
      switch (errResp.status) {
        // Unauthorised / Redirect
        case 401:
        case 302:
          // Navigate to the login/redirect location
          await this.#setContentOnLoad(errResp.responseJSON.location);
          break;

        default:
          this.#handleContentLoadError(errResp, urlObj);
      }
    }
    finally {
      this.#setUiLoaded();
    }
  }

  #setUiLoading() {
    this.#ui.spinner.removeClass("hidden");
    this.#ui.content.addClass("hidden");
  }

  #setUiLoaded() {
    this.#ui.spinner.addClass("hidden");
    this.#ui.content.removeClass("hidden");
  }

  #scrollToContent() {
    window.scroller.scrollToElemTop(this.#ui.content);
  }

  #handleContentLoadError(errResp, urlObj) {
    // There is an error page, so we can display it.
    if (errResp.contentType != null && errResp.contentType.includes("text/html")) {
      this.#setContent(errResp.responseText);
      this.#ui.container.trigger("content-loaded", { url: urlObj });
      return;
    }

    // Else there is no error page.
    // This needs to be handled by the page
    throw errResp;
  }
}
